var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankBoa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 23,
    viewBox: "0 0 32 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 23,
    rx: 3,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9625 17.9993C19.7521 14.7553 25.0756 11.6014 27.999 10.4659C27.5478 10.1776 26.844 9.76306 26.05 9.3125C22.2785 10.556 17.8754 13.3135 13.9414 16.4314C14.6091 16.936 15.3129 17.4586 15.9625 17.9993Z",
    fill: "#E31837"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2333 9.18423C13.6739 8.9139 13.0603 8.66158 12.5912 8.44531C11.1656 9.14819 9.30687 10.2115 6.96094 11.8876C7.46621 12.1579 8.00758 12.4823 8.58504 12.8067C10.3896 11.4731 12.2122 10.2115 14.2333 9.18423Z",
    fill: "#012169"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.606 7.64004C16.9202 7.26157 14.5382 6.37847 12.8961 6C12.4088 6.18022 11.7231 6.45056 11.2539 6.64881C11.8494 6.81101 14.069 7.40575 15.9638 8.36094C16.451 8.12665 17.1368 7.83829 17.606 7.64004Z",
    fill: "#E31837"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54001 7.40625C7.42867 8.37946 5.20906 9.71312 4 10.4881C4.43309 10.6863 4.86619 10.8485 5.46169 11.1369C8.13244 9.33465 10.2257 8.23528 11.0558 7.87483C10.4603 7.65856 9.90092 7.51438 9.54001 7.40625Z",
    fill: "#012169"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1934 7.08039C19.6806 6.91819 20.24 6.77401 20.7272 6.62983C19.3197 6.03509 17.5512 5.40431 15.9632 5.00781C15.7106 5.0799 14.9526 5.27815 14.4293 5.44035C14.9707 5.60255 16.7572 6.01707 19.1934 7.08039ZM10.2969 13.8568C10.8743 14.1993 11.4879 14.6678 12.0834 15.0643C16.0354 12.0005 19.9332 9.63958 24.21 8.30592C23.6145 7.99954 23.0912 7.7292 22.4235 7.4048C19.861 8.05361 15.476 9.80178 10.2969 13.8568Z",
    fill: "#E31837"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankBoa);
export default __webpack_public_path__ + "static/media/BankBOA.158f4728b62128cc2ecc4cfcf4c7ebfd.svg";
export { ForwardRef as ReactComponent };